import { MenuItem } from "../../interface/Server";
export interface State {
    menu?: MenuItem[],
    showLoading?: boolean,
    hasToken?: boolean,
    language?: string,
    debugMode?: boolean,
    publicKey?: string,
}

export const state: State = {
    menu: [],
    showLoading: false,
    hasToken: false,
    language: '',
    debugMode: false,
};

export default state;

